
import VectorSource from 'ol/source/Vector';

import DrawGeometry from './DrawGeomerty';

function createInteractionDrawLine(options) {
    let source = new VectorSource({});

    let draw = new DrawGeometry({
        source: source,
        type: 'LineString'
    });

    draw.set('mapToolId', 'DrawLine');
    draw.setActive(false);

    draw.on('drawend', (e) => {
        if (options.onMapToolExecute) {
            options.onMapToolExecute(
                draw.get('mapToolId'),
                {
                    feature: e.feature
                }
            );
        }
    });

    return draw;
}

export default createInteractionDrawLine;
